"use client";

import PageError from "@shared/ui/error/page-error";

interface ProductPageErrorProps {
  error: Error & { digest?: string };
  reset(): void;
}

export default function ProductPageError(props: ProductPageErrorProps) {
  return <PageError {...props} fallbackPath="/product" />;
}
